import jquery from "jquery"

window.jQuery = jquery // required for many jQuery plugins
window.$ = jquery
